export default "__VITE_ASSET__$F5IuinT__"